import { GetIncidentRequest, GetIncidentResponse } from '@/types/apis/incident'

import axios from './axios'

const API_ENDPOINT = '/incident'

export const getIncident = (request: GetIncidentRequest): Promise<GetIncidentResponse> => {
  return axios.get(API_ENDPOINT, { params: request })
}
